import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import moment from 'moment';
import { IWeissmanModalComponent } from '../../Compliance/WeissmanModalService';

export interface AddTaxYearModalParams {
    yearsAlreadyAdded: number[];
}

@Component({
    selector: 'add-tax-year-modal',
    template: `
        <ws-modal-wrapper headerLabel="Add Tax Year"
          acceptLabel="Add"
          (save)="add()"
          (cancel)="closeModal()">
          <div class="form-group">
            <select class="form-select-sm" [(ngModel)]="yearToAdd" style="width: auto;">
              @for (year of years; track year) {
                <option [ngValue]="year">{{ year }}</option>
              }
            </select>
          </div>
        </ws-modal-wrapper>
        `,
    standalone: false
})
export class AddTaxYearModalComponent implements IWeissmanModalComponent<AddTaxYearModalParams, number>, OnInit {
    constructor(public bsModalRef: BsModalRef) {
    }

    params: AddTaxYearModalParams;
    result: number;

    years: number[];
    yearToAdd: number;

    ngOnInit() {
        const currentYear: number = Number(moment().format('YYYY'));
        const years = _.range(currentYear - 10, currentYear + 5);

        this.years = _.chain(years)
            .without(...this.params.yearsAlreadyAdded)
            .reverse()
            .value();


        //console.log('this.yearToAdd', this.yearToAdd);

        if (this.params.yearsAlreadyAdded && _.max(this.params.yearsAlreadyAdded))
            this.yearToAdd = _.max(this.params.yearsAlreadyAdded) + 1;

        if (!this.yearToAdd)
            this.yearToAdd = currentYear;
    }

    add() {
        this.result = this.yearToAdd;
        this.bsModalRef.hide();

    }

    closeModal() {
        this.bsModalRef.hide();
    }
}
